import { EMPTY_LIST } from '../../../../constants/common'
import { useWidgetContext } from '../../Widget.hooks'
import { ProfileInfoWidgetForm } from '../ProfileInfoWidgetForm'
import { ProfileInfoWidgetReadView } from '../ProfileInfoWidgetReadView'

function ProfileInfoWidgetContent({
  NotesField,
  config = EMPTY_LIST,
  data,
  isSectionsExpanded,
  options,
  onClickEmail,
  onSubmit,
}) {
  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  return isEditMode ? (
    <ProfileInfoWidgetForm
      NotesField={NotesField}
      config={config}
      data={data}
      options={options}
      onClose={handleDisableEditMode}
      onSubmit={onSubmit}
      onSuccess={handleDisableEditMode}
    />
  ) : (
    <ProfileInfoWidgetReadView
      config={config}
      data={data}
      isSectionsExpanded={isSectionsExpanded}
      onClickEmail={onClickEmail}
    />
  )
}

export default ProfileInfoWidgetContent
